export enum ESubscription {
  SERENITY_US = 'SERENITY_US',
}
